import React from "react";
import styles from "./BuildControls.module.css";
import BuildControl from "./BuildControl/BuildControl";
const controls = [
  { label: "Salad", type: "salad" },
  { label: "Meat", type: "meat" },
  { label: "Cheese", type: "cheese" },
  { label: "Bacon", type: "bacon" },
];
const buildControls = (props) => (
  <div className={styles.BuildControls}>
    <p>
    <strong>Current Price: Rs. {props.price.toFixed(2)}</strong>
    </p>
    {controls.map((ctrl) => (
      <BuildControl
        key={ctrl.label}
        label={ctrl.label}
        added={() => props.ingredientAdded(ctrl.type)}
        removed={() => props.ingredientRemoved(ctrl.type)}
        disabled={props.disabled[ctrl.type]}
      />
    ))}

    <button className={styles.OrderButton} disabled={!props.purchasable}
    onClick={props.ordered}>
      {props.isAuth? "PLACE ORDER" : "Login to Order"}
    </button>

  </div>
);

export default buildControls;

// .toFixed(num) rounds a decimal up to "num" number of decimal places.
